// extracted by mini-css-extract-plugin
export default {"collaborator-icon":"y4UhnsjoBx","collaboratorIcon":"y4UhnsjoBx","hint":"FdmRd+JXqE"};
    if(module.hot) {
      // 1650538081617
      var cssReload = require("!../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  